<h1 class="text-4xl font-bold bg-clip-text py-4">
  @if (loading() === true) {
    &nbsp;
  } @else {
    {{ title() ?? 'LOOP Credentials' }}
  }
</h1>

<div class="relative w-full max-w-sm mx-auto aspect-[16/10] rounded-xl overflow-hidden shadow-md" [class.desktop]="!platform.isMobile()">
  @if (loading() === true) {
    <div class="absolute inset-0 animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 z-0"></div>
  } @else {
    <img alt="Badge"
         class="absolute inset-0 w-full h-full object-cover z-10"
         [src]="image() ?? '/assets/card-loop.png'"
    />
  }

</div>

@if (subtitle()) {
  <h2 class="text-xl font-medium py-4">
    {{ subtitle() }}
  </h2>
}

@if (errorSubtitle()) {
  <h2 class="text-xl font-medium text-red-500 dark:text-red-400  py-4">
    {{ errorSubtitle() }}
  </h2>
}
